import React, { PropsWithChildren, ReactNode } from 'react';
import { Cell, Grid }                          from "styled-css-grid";


interface ItemWithIconProps extends PropsWithChildren<any> {
    rtl?: boolean,
    gap?: string,
    middleAlign?: boolean,
    iconComponent?: ReactNode
}

const ItemWithIconDefaultProps = {
    rtl:           false,
    gap:           '10px',
    middleAlign:   true,
    iconComponent: null,
} satisfies Partial<ItemWithIconProps>

function ItemWithIcon( { children, ...p }: ItemWithIconProps ){

    const props = { ...ItemWithIconDefaultProps, ...p };

    return (
        <Grid
            gap={ props.gap }
            columns={ props.rtl ? `1fr auto` : `auto 1fr` }
            areas={ props.rtl ? [ 'content icon' ] : [ 'icon content' ] }>

            <Cell middle={ props.middleAlign } area={ 'icon' }>{ props.iconComponent }</Cell>
            <Cell middle={ props.middleAlign } area={ 'content' } className={ 'text-left' }>{ children }</Cell>

        </Grid>
    );
}

export {
    ItemWithIcon,
    ItemWithIconDefaultProps,
    type ItemWithIconProps,
};
